import {Player} from "./player";
import {Monster} from "./monster";

export class Accuracy {


  constructor(player, setup, monster) {
    this.player = new Player(player, setup);
    this.setup = setup;
    this.monster = new Monster(monster, setup, player);
  }

  accuracy() {
    let acc = this.hitChance() * 100;
    return acc.toFixed(2) + '%'
  }

  hitChance() {
    if (this.maxAttackRollWeaponBoosted() > this.maxDefenceRoll()) {
      //  hit_chance = 1 - (max_defence_roll + 2) / (2 * (max_attack_roll + 1))
      return 1 - (this.maxDefenceRoll() + 2) / (2 * (this.maxAttackRollWeaponBoosted() + 1))
    }
    //  hit_chance = max_attack_roll / (2 * max_defence_roll + 1)
    return this.maxAttackRollWeaponBoosted() / (2 * this.maxDefenceRoll() + 1)
  }

  maxAttackRollWeaponBoosted() {
    let salveBoost = this.player.salveBoost(this.monster);

    //Salve bonus is taken ove slayer boost
    let slayerMultipler = salveBoost > 1 ? salveBoost : this.player.slayerBoost();
    let boosted = this.maxAttackRoll() * slayerMultipler;
    // console.debug('maxAttackRollWeaponBoosted', boosted, salveBoost, this.player.slayerBoost());

    return Math.floor(Math.floor(boosted) * this.weaponAccuracyMultiplier());
  }

  /**
   * Effective level of current combat style
   * @returns {number}
   */
  effectiveLevel() {
    switch (this.player.activeWeaponType()) {
      case 'melee':
        return this.accuracyEffectiveLevel('attack'); //TODO Check
      // return Math.floor(this.monster[`defence_${this.stanceKey}`] * (this.maxAttack + 64));
      case 'ranged':
        return this.accuracyEffectiveLevel('ranged'); //This seems to be ok
      case 'magic':
        return this.accuracyEffectiveLevel('magic'); //TODO Check
    }
    return 0;
  }

  maxAttackRoll() {
    switch (this.player.activeWeaponType()) {
      case 'melee':
        return Math.floor(this.accuracyEffectiveLevel('attack') * (this.maxAttack() + 64)); //TODO Check
      // return Math.floor(this.monster[`defence_${this.stanceKey}`] * (this.maxAttack + 64));
      case 'ranged':
        return Math.floor(this.accuracyEffectiveLevel('ranged') * (this.maxAttack() + 64)); //This seems to be ok
      case 'magic':
        return Math.floor(this.accuracyEffectiveLevel('magic') * (this.maxAttack() + 64)); //TODO Check
    }
  }

  maxAttack() {
    let style = `attack_${this.player.stanceKey()}`;
    let atkBonus = this.player.equipBonus()[style];
    return atkBonus;
  }

  maxDefenceRoll() {
    let effectiveLevel = 0;

    switch (this.player.activeWeaponType()) {
      case 'ranged':
        effectiveLevel = this.monster.getLevel('defence');
        break;
      case 'magic':
        effectiveLevel = this.monster.getLevel('magic');
        if (this.monster.id === 494) //Kraken
          effectiveLevel = effectiveLevel + 1;

        break;
      default: //This accounts for mage with no spell selected
      case 'melee':
        effectiveLevel = this.monster.getLevel('defence');
        break;
    }

    let equipmentBonus = this.monster.getDefensiveStat(this.player.stanceKey());
    return (9 + effectiveLevel) * (equipmentBonus + 64)
  }


  weaponAccuracyMultiplier() {
    switch (this.player.activeWeaponType()) {
      case 'melee':
        return this.equipmentAccuracy_attack();
      case 'ranged':
        return this.equipmentAccuracy_ranged();
      case 'magic':
        return this.equipmentAccuracy_magic();
    }

    return 1
  }

  accuracyEffectiveLevel(skill) {
    let boostedLevel = this.player.visibleLevel(skill);
    let prayerBonus = (1 + (this.player.prayerBonuses()[skill] / 100)).toFixed(3);
    let prayerBoosted = Math.floor(boostedLevel * prayerBonus);
    let stanceBonus = this.accuracyStanceBonus() + 8;
    let totalBonus = prayerBoosted + stanceBonus;

    if (this.player.isVoidSetEquipped()) {
      totalBonus = totalBonus * this.voidSetAccuracyBonus();
      // console.log('accuracyEffectiveLevel void set equipped', [this.player.isVoidSetEquipped(), this.voidSetAccuracyBonus(), totalBonus]);
    }


    // console.log('accuracyEffectiveLevel-', {
    //   skill: skill,
    //   boostedLevel: boostedLevel,
    //   prayerBonus: prayerBonus,
    //   accuracyStanceBonus: stanceBonus,
    //   prayerBoosted: prayerBoosted,
    //   voidBonuis: this.voidSetAccuracyBonus(),
    //   totalBonus: totalBonus
    // });

    return Math.floor(totalBonus)
  }

  voidSetAccuracyBonus() {
    let mageHelm = 11663;
    let rangedHelm = 11664;
    let meleeHelm = 11665;

    if (!this.player.isVoidSetEquipped())
      return 1;

    switch (this.setup.equipment.head.id) {
      case mageHelm:
        return 1.45;
      case rangedHelm:
        return 1.10;
      case meleeHelm:
        return 1.10;
    }
    return 1;
  }

  accuracyStanceBonus() {
    switch (this.player.activeWeaponType()) {
      case 'melee':
        switch (this.setup.activeStance.attack_style) {
          case 'accurate':
            // case 'defensive':
            return 3;
          case 'controlled':
            return 1;
          default:
            return 0
        }

      case 'ranged':
        switch (this.setup.activeStance.combat_style) {
          case 'accurate':
          case 'longrange':
            return 3;
          case 'controlled':
            return 1;
          default:
            return 0
        }

      case 'magic':
        if (!this.player.isTridentEquipped()) {
          return 0;
        }
        switch (this.setup.activeStance.combat_style) { //Trident only
          case "accurate":
            return 3;
          case "longrange":
            return 1;
          default:
            return 0
        }

      default:
        return 0;
    }
  }

  equipmentAccuracy_attack() {
    //Set effects:
    if (this.player.isObsidianSetEquipped()) {
      return 1.10;
    }

    //Crystal armour - 3% damage boost and 6% accuracy bonus to the crystal bow.
    if (this.player.isCrystalSetEquipped()) {
      let count = this.player.crystalArmourSetCount();
      if (count === 4)
        return 0.35;
      return 1 + (0.06 * count);
    }


    switch (this.setup.equipment.weapon.id) {
      // Darklight: 1.60 (vs. demons)
      case 6746:
        if (this.monster.isDemonMonster()) {
          return 1.60;
        }
      // Arclight: 1.70 (vs. demons)
      case 19675:
        if (this.monster.isDemonMonster()) {
          return 1.70;
        }
        break;
      // Dragon Hunter Lance 1.20 ( vs dragons)
      case 22978:
        if (this.monster.isDragonMonster()) {
          return 1.20;
        }
        break;
      // Viggora's chainmace 1.5 in wilderness
      case 22545:
        if (this.player.inWilderness())
          return 1.5;
        break;

      //TODO These are special attack multipliers?
// • Abyssal dagger: 1.25
//           case 13271:
//           case 13269:
//           case 13267:
//           case 13265:
//             return 1.25;
// • Abyssal whip: 1.25
//           case 4151:
//           case 12773:
//           case 12774:
//             return 1.25;
// • Barrelschest anchor: 2.00
//           case 10887:
//           case 10888:
//             return 2.00;
// • Dinh's Bulwark: 1.20
//           case 21015:
//             return 1.20;
// • Dragon dagger: 1.15
//           case 1215:
//           case 1231:
//           case 5680:
//           case 5698:
//             return 1.15;
// • Dragon mace: 1.25
//           case 1434:
//             return 1.25;
// • Dragon scimitar: 1.25
//           case 4587:
//           case 20000:
//             return 1.25;
// • Dragon sword: 1.25
//           case 21009:
//             return 1.25;
// • Godsword, any: 2.00
//           case 20368:
//           case 20370:
//           case 20372:
//           case 20374:
//           case 20782:
//           case 11802:
//           case 11804:
//           case 11806:
//           case 11808:
//             return 2.00;
// * Rune claws: 1.15
//           case 3101:
//             return 1.15;
// • Saradomin sword & Saradomin's blessed sword: 2.00: 2.00
//           case 11838:
//           case 12809:
//             return 2.00;
    }

    return 1;
  }


  equipmentAccuracy_ranged() {
    switch (this.setup.equipment.weapon.id) {
// • Dragon hunter crossbow: 1.10 (vs. dragons, wyverns, Great Olm)
      case 21012:
        if (this.monster.isDragonMonster())
          return 1.30; //25 Jan  2018 update from 10% -> 30%
        break;
// Craws bow 1.5 in wilderness:
      case 22550:
        if (this.player.inWilderness())
          return 1.5;
        break;
// • Twisted bow: (140 + truncate[(3*magic-10) /100] - truncate[(0.3magic-100)² / 100]) /100
      case 20997:
        // TODO in/out chambers
        let cappedMagicLevel = Math.min(this.monster.getLevel('magic'), 250);

        let p1 = (3 * (cappedMagicLevel - 10)) / 100;
        let p2 = Math.pow(0.3 * cappedMagicLevel - 100, 2) / 100;

        return Math.min(140, ((140 + p1 - p2))) / 100;
    }

    return 1;
  }


  equipmentAccuracy_magic() {
    let bonus = 1;

    // =IF($B19,TRUNC(0.1*'Sheet 1'!$E81)/4,0) - Brimstone ring   has a 25% chance to ignore 10% of the target's total magic defence.
    //TODO Test
    if (this.player.isBrimstoneRingEquipped()) {
      let brimstoneBonus = (0.1 * this.maxDefenceRoll()) / 4;
      bonus = bonus + brimstoneBonus
    }


    // Smoke staff: 1.10 (normal spellbook only)
    if (this.setup.activeSpellbook === 'standard')
      if (this.setup.equipment.weapon.id === 11998)
        return bonus + 0.1;

    // Thammaron's sceptre	2.0 when in wilderness
    if (this.player.inWilderness()) {
      if (this.player.isWeaponEquipped([22552, 22555]))
        return bonus + 1;
    }

    return bonus;
  }

}



// WEBPACK FOOTER //
// ./src/js/accuracy.js